/**
 * Breadcrumb
 */

// Custom
import 'protons';

// Module template
import './_breadcrumb.twig';
import './_breadcrumb.css';

export const name = 'breadcrumb';

export function disable() {}

export function enable() {}

export default enable;
